export default {
    getUrlParameter (sParam, defaultValue) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName.length === 2 ? decodeURIComponent(sParameterName[1]) : defaultValue;
            }
        }
        return defaultValue;
    },
    parameterExist (sParam) {
        var value = this.getUrlParameter(sParam, undefined);
        return value !== undefined;
    }
  };